import React from 'react';

import HomeVisits from './services/HomeVisits';
import VideoConsultations from './services/VideoConsultations';
import FamilyPhysicians from './services/FamilyPhysicians';
import LabTests from './services/LabTests';
import SeniorCitizens from './services/SeniorCitizens';
import Vaccinations from './services/Vaccinations';
import InnerHeroBanner from './InnerHeroBanner';
import { Helmet } from 'react-helmet-async';

export default function OurServices() {
  return (
    <>
      
      <Helmet>
        <title>Our Services - Family Doctors at Home</title>
        <meta
          name="description"
          content="Explore our range of home healthcare services including doctor visits, video consultations, family physicians, lab tests, senior citizen care, and vaccinations."
        />
        <meta
          name="keywords"
          content="home doctor visit, video consultation, family physician, lab tests at home, senior citizen care, vaccinations at home"
        />
      </Helmet>
      <InnerHeroBanner />
      <div className='our-services'>
       
        <HomeVisits />
        <VideoConsultations />
        <FamilyPhysicians />
        <LabTests />
        <SeniorCitizens />
        <Vaccinations />
      </div>
    </>
  );
}
